export const LISTE_ORDRE_TRAVAIL_AFFICHAGE = {
  title: 'Ordres de travail - Liste d\'affichage',
  breadcrumb: {
    racine: 'Accueil',
    ordresTravails: 'Ordres de travail',
  },
  actions: {
    edit: 'Modifier',
    delete: 'Supprimer',
    search: 'Recherche',
    editionMasse: 'Générer édition',
  },
  tabs: {
    numberOT: 'N° ordre de travail',
    listeAffichage: 'Liste d\'affichage',
    afficheur: 'Afficheur',
    etat: 'Etat',
    dateDepart: 'Date de départ',
    nFacesPrevues: 'Faces prévues',
    nFacesAffichees: 'Faces affichées',
    nGrattageEffectues: 'Grattages effectués',
    nFacesLaisserEnPace: 'Faces laissées en place',
    agence: 'Agence',
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    afficheur: 'Afficheur(s)',
    agence: 'Agence(s)',
    etat: 'Etat(s)',
    actions: {
      search: 'Rechercher',
      noResult: 'Aucun résultat',
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cet ordre de travail ?',
    titleCode: 'Etes-vous sûr de vouloir supprimer l\'ordre de travail {code} ?',
    titleMutlti: 'Êtes-vous sûr de vouloir supprimer ces ordres de travail ?',
    yes: 'Oui',
    no: 'Non',
  },
  etat: {
    enregistre: 'Enregistré',
    clos: 'Clos',
    realise: 'Réalisé',
  },
  messages: {
    success: {
      otDelete: 'Ordre de travail supprimé avec succès',
      otMulti: 'Les ordres de travail ont été supprimées avec succès.',
    },
    error: {
      otNotDelete: 'L\'ot {code} ne peut être supprimé car il est à l\'état "clos".',
      otQuantiteNonValide: 'La face {code} ne peut pas avoir un affichage et un laisser en place en même temps.',
    },
  },
  faces: {
    prevues: 'Faces prévues',
    aAfficher: 'Faces à afficher',
    gratter: 'Grattage',
    laisserEnPlace: 'Laisser en place',
  },
};

export const DETAIL_ORDRE_TRAVAIL_AFFICHAGE = {
  title: 'Ordre de travail n°{code}',
  actions: {
    cancel: 'Retour',
    cloture: 'Clôturer l\'OT',
    editer: 'Modifier',
    delete: 'Supprimer',
    export: 'Exporter',
    accesAffectation: 'Voir les affectations logistique',
    reactiver: 'Réactiver',
    ajouterFace: 'Ajouter faces',
  },
  breadcrumb: {
    racine: 'Accueil',
    ordreTravail: 'Ordres de travail',
    detailOrdreTravailAffichage: 'Détail ordre de travail',
  },
  popUpMail: {
    title: 'Rédiger votre email',
    inclureOt: 'Inclure l\'OT',
    otObject: 'Ordre de travail affichage {code}',
  },
  legende: {
    legende: 'Légende',
    laisserEnPlace: 'Laisser en place',
    manuel: 'Manuel',
  },
  informations: {
    title: 'Ordre de travail',
    listeAffichage: 'Liste d’affichage :',
    afficheur: 'Afficheur :',
    dateDepart: 'Date de départ :',
    etat: 'Etat :',
    commentaires: 'Commentaires :',
    agence: 'Agence :',
  },
  popUpEdition: {
    otAvecLaisserEnPlace: 'Avec laisser en place',
    otAvecDetailManuel: 'Avec détail du manuel',
    otAvecReseau: 'Avec réseau',
  },
  popUpClocture: {
    title: 'Etes-vous sûr de vouloir clôturer cet ordre de travail ?',
    success: 'Ordre de travail cloturé avec succès ',
    error: 'Imposible de clôturer l\'ordre de travail s\'il n\'est pas à l\'état enregistré',
  },
  popUpReactive: {
    title: 'Etes-vous sûr de vouloir réactiver cet ordre de travail ?',
    success: 'Ordre de travail réactivé avec succès',
    error: 'Imposible de réactiver l\'ordre de travail s\'il est à l\'état enregistré',
  },
  annonceur: {
    title: 'Annonceurs ({nbAnnonceur})',
    prevues: 'Prévues',
    affichees: 'Affichées',
    grattees: 'Grattées',
    remplacees: 'Nombre de faces remplacées',
  },
  tab: {
    image: 'Image',
    ordre: 'Ordre',
    panneaux: 'Panneaux',
    panneau: 'Panneau n°{code}',
    format: 'Format',
    nbFaces: 'Nb de faces',
    disposition: 'Disposition',
    faceNb: 'n° ',
    addCommentaire: 'Ajouter un commentaire',
    faces: 'Faces',
    pose: 'Pose',
    commentaire: 'Commentaire',
    restriction: 'Restriction',
    affichageEffectue: 'Affichage effectué',
    laisserEnPlace: 'Laissez en place',
    affichagePrecedent: 'Campagne Précédente',
    grattage: 'Grattage',
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cet ordre de travail ?',
    yes: 'Oui',
    no: 'Non',
  },
  messages: {
    success: {
      otDelete: 'Ordre de travail supprimé avec succès',
    },
    errors: {
      otIdObligatoire: 'L\'id de l\'ordre de travail est obligatoire',
    },
  },
};

export const MODIFICATION_ORDRE_TRAVAIL_AFFICHAGE = {
  title: 'Modification ordre de travail n°{code}',
  actions: {
    cancel: 'Retour',
    cloture: 'Clôturer l\'OT',
    editer: 'Modifier',
    affichage: 'Afficher / Ne pas Afficher',
    laisserEnPlace: 'Laisser en place / Ne pas Laisser en place',
    grattage: 'Gratter / Ne pas Gratter',
  },
  breadcrumb: {
    racine: 'Accueil',
    ordreTravail: 'Ordres de travail',
    detailOrdreTravailAffichage: 'Détail ordre de travail',
    title: 'Modification ordre de travail n°{code}',
  },
  informations: {
    title: 'Ordre de travail',
    modificationAfficheur: 'Modifier l\'afficheur',
    listeAffichage: 'Liste d’affichage :',
    afficheur: 'Afficheur :',
    dateDepart: 'Date de départ :',
    etat: 'Etat :',
    commentaires: 'Commentaires :',
    agence: 'Agence :',
  },
  annonceur: {
    title: 'Annonceur ({nbAnnonceur})',
  },
  popUpAfficheur: {
    title: 'Modifier l\'afficheur',
    replaceAfficheur: 'Remplacer l\'afficheur',
    afficheur: 'Afficheur',
    actions: {
      annuler: 'Annuler',
      modifier: 'Modifier',
      searchEnCours: 'Recherche...',
      noResult: 'Aucun résultat',
    },
  },
  popUpAjoutFace: {
    title: 'Ajout de faces',
    description: 'Veuillez définir l\'action de pose :',
    annonceur: 'Annonceur',
    theme: 'Thème',
    autre: 'Autre',
    selection: 'Sélection des faces',
    titleBox: 'Visuel a poser',
    poseInfo: 'Pose :',
    annonceurInfo: 'Annonceur:',
    themeInfo: 'Thème:',
    actionErrors: {
      noSelected: 'La sélection de l\'action de pose est obligatoire',
      noTheme: 'Si "Autre", veuillez définir la pose dans la colonne "Thème"',
    },
  },
  popUpCommentaire: {
    title: 'Ajouter un commentaire',
    faceReference: 'Face :',
    editCommentaire: 'Modifier le commentaire',
    affichageEffectue: 'Affichage effectué',
    laisserEnPlace: 'Laisser en place',
    oui: 'Oui',
    non: 'Non',
    texte: 'Texte',
    commentaire: 'Commentaire',
    actions: {
      annuler: 'Annuler',
      ajouter: 'Ajouter',
      modifier: 'Modifier',
    },
  },
  messages: {
    success: {
      otSave: 'Ordre de travail modifié avec succès',
    },
    errors: {
      afficheurObligatoire: 'L\'afficheur est requis pour la modification de l\'ordre de travail.',
      auMoinsUneFace: 'Il faut au moins une face dans l\'ot',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer la face {face}',
  },
  remplacementFaceOT: {
    title: 'Remplacement de la face dans l\'ot',
    remplacer: 'Remplacer',
    commentaire: 'Cette face a été remplacée par la face {face}',
    noSelection: 'Veuillez sélectionner une face',
    detail: {
      title: 'Face à remplacer',
      codeFace: 'Face:',
      codePanneau: 'Panneau: ',
      adresse: 'Adresse: ',
      format: 'Format: ',
      pose: 'Visuel à poser: ',
    },
    breadcrumb: {
      racine: 'Accueil',
      ordreTravail: 'Ordres de travail',
      modificationOrdreTravailAffichage: 'Modification d\'un ordre de travail',
      title: 'Remplacement d\'une face dans un OT',
    },
  },
  ajouterFaceOT: {
    title: 'Ajouter une face dans l\'ot',
    ajouter: 'Ajouter',
    noSelection: 'Veuillez selectionner une face',
    alreadyExist: 'La face {faceReference} est déjà dans l\'OT ',
    breadcrumb: {
      racine: 'Accueil',
      ordreTravail: 'Ordres de travail',
      modificationOrdreTravailAffichage: 'Modification d\'un ordre de travail',
      title: 'Ajouter une face dans l\'ot',
    },
  },
  popupAffichageGrattage: {
    title: {
      affichage: 'Modification des affichages',
      laisserEnPlace: 'Modification des laisser en place',
      grattage: 'Modification des grattages',
    },
    afficher: 'Affichage effectué',
    laisserEnPlace: 'Laisser en place',
    gratter: 'Grattage effectué',
    texte: 'Texte',
    commentaire: 'Commentaire',
  },
};

export const AFFECTATION_ORDRE_TRAVAIL_AFFICHAGE = {
  title: 'Gestion des affectations',
  breadcrumb: {
    detailOrdreTravailAffichage: 'Détail ordre de travail',
    affectationLogistique: 'Affectation Logistique',
  },
  informationOt: {
    title: 'Ordre de travail n°{code}',
    listeAffichage: 'Liste d’affichage : {listeAffichage}',
    dateDepart: 'Date de départ : {date}',
  },
};
